export { CvDetailTabsPlaceholder } from './CvDetailTabsPlaceholder';
export { CvDetailSkillsPlaceholder } from './CvDetailSkillsPlaceholder';
export { CvDetailExperiencePlaceholder } from './CvDetailExperiencePlaceholder';
export { CvDetailProfileHeadingPlaceholder } from './CvDetailProfileHeadingPlaceholder';
